module.exports = __webpack_public_path__ + "img/sigorta.d615015b.png";